import cx from 'classnames';
import React, { CSSProperties } from 'react';

import './styles/Row.scss';

export type RowSize =
  | 'xxxxxxlarge'
  | 'xxxxxlarge'
  | 'xxxxlarge'
  | 'xxxlarge'
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'xsmall'
  | 'xxsmall'
  | 'xxxsmall'
  | 'xxxxsmall';

export type Props = {
  size?: RowSize;
  flush?: boolean;
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  'data-testid'?: string;
};

export default class Row extends React.Component<Props> {
  render() {
    const { size = 'xxlarge', flush = false, children, className, style } = this.props;

    return (
      <div
        className={cx('Row', !flush && `Row--${size}`, flush, className)}
        style={style}
        data-testid={this.props['data-testid']}
      >
        {children}
      </div>
    );
  }
}
